import React from "react";
import "./Header.css";

function Header({
  planType,
  mets,
  price
}) {


  let reactHeaderCol = "";
  let displayPrice = "";
  let reactHeaderPrice = ""

  if (price !== "Contact Us"){
    reactHeaderCol = `react-header-col-${planType === "Mission Critical" ? "Emc" : planType}`
  } else if (price === "Contact Us"){
    reactHeaderCol = (planType === "Mission Critical") ? "react-header-col-Emc": "react-header-col-non-emc-contact";
  }

  if (price === 0){
    displayPrice = "Contact Us";
    reactHeaderCol = (planType === "Mission Critical") ? "react-header-col-Emc": "react-header-col-non-emc-contact";
    reactHeaderPrice = (<span className="react-header-input-text">{displayPrice}</span>)
  } else {
    displayPrice = price;
    let formattedPrice = Intl.NumberFormat().format(price);
    reactHeaderPrice = (
      <div>
        <span className="react-header-dollarSign">$</span>
        <span 
          className="react-header-input-price" 
          >
            {formattedPrice}
        </span>
        <span className="react-header-subscript">/mo
        </span>
      </div>   
    );
  }


  return (
    <div className="react-header-wrapper">
        <div className="react-header-container">
            <div className="react-header-row">
              <div className={reactHeaderCol}>
                <div className="react-header-title">plan type</div>
                <div className="react-header-inner-padding">
                  <span className="react-header-input-text">{planType}</span>
                </div>
              </div>

               <div className={reactHeaderCol}>
                <div className="react-header-title">striim events</div>
                <div className="react-header-inner-padding">
                  <span className="react-header-input-text">{mets}</span>
                </div>
              </div>

               <div className={reactHeaderCol}>
                <div className="react-header-title">starting from</div>
                <div className={ price === 0? "react-header-inner-padding" : "react-header-no-padding"}>
                  {reactHeaderPrice}
                </div>
              </div>

            </div>
        </div>
    </div>
  );
}

export default Header;
